// https://standards.buildingsmart.org/IFC/RELEASE/IFC2x3/TC1/HTML/ifcproductextension/lexical/ifccoveringtypeenum.htm
enum IfcCoveringTypeEnum {
    CEILING = "CEILING",
    FLOORING = "FLOORING",
    CLADDING = "CLADDING",
    ROOFING = "ROOFING",
    INSULATION = "INSULATION",
    MEMBRANE = "MEMBRANE",
    SLEEVING = "SLEEVING",
    WRAPPING = "WRAPPING",
    USERDEFINED = "USERDEFINED",
    NOTDEFINED = "NOTDEFINED", // A door with a not defined operation type is considered as a door with a lining, but no panels. It is thereby always open.
  }
  

export default IfcCoveringTypeEnum;